import { useState, useRef, useEffect } from "react";
import { Grid, TextField, MenuItem, InputLabel, Typography, Button, Select } from "@material-ui/core";
import FileUploadService from 'services/FileUploadService';
import Clear from '@material-ui/icons/Clear';
import { checkSupportedFormat, checkUploadedFileSize } from "utils/common";
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import { useStyles } from "./style";
import { buildQueryParams } from "utils/common";
import _ from "lodash";
import { BootstrapInput } from "containers/labs/style";


const fileUploadServiceObj = new FileUploadService();

export default function FileUpload(props) {
    const { labId } = props;
    const classes = useStyles();
    const [fileData, setFileData] = useState([]);
    const [resourceUrl, setResourceUrl] = useState("");
    const [resourceName, setResourceName] = useState("");
    const [selectedresourceType,  setSelectedResourceType] = useState("");
    const [imageName, setImageName] = useState("");
    const [imagDescription, setImageDescritption] = useState("");
    const supportedFileTypes = ["doc", "docx", "xls", "xlsx", "pdf", "jpg", "jpeg", "png"];
    const [resourceType] = useState([
        { id: 1, label: 'Architecture Guide', value: 'Architecture Guide' },
        { id: 2, label: 'Blog', value: 'Blog' },
        { id: 3, label: 'Certification', value: 'Certification' },
        { id: 4, label: 'Customer Use Case', value: 'Customer Use Case' },
        { id: 5, label: 'Implementation Guide', value: 'Implementation Guide' },
        { id: 6, label: 'Interoperability', value: 'Interoperability' },
        { id: 7, label: 'Performance Report', value: 'Performance Report' },
        { id: 8, label: 'Reference Architecture', value: 'Reference Architecture' },
        { id: 9, label: 'Security', value: 'Security' },
        { id: 10, label: 'Sizing', value: 'Sizing' },
        { id: 11, label: 'Tool', value: 'Tool' },
        { id: 12, label: 'Video', value: 'Video' },
        { id: 13, label: 'White Paper', value: 'White Paper' }

    ]);
    const supportedFileMaxSize = 10;
    const myRef = useRef([]);


    const getALLResource = () => {
        const resourceUrlParams = { object_id: labId, is_deleted: false };
        fileUploadServiceObj.getResourceUrlByLabId(buildQueryParams(resourceUrlParams)).then(response => {
            if (response) {
                const { results } = response;
                if (results && results.length > 0) {
                    setFileData(results);
                } else { setFileData([]) }

            }
        }).catch(error => {
            console.log(error)
        })
    }
    useEffect(() => {
        if (labId > 0) {
            getALLResource();
        }
        // eslint-disable-next-line
    }, [])

    const createFormPayload = async (event, file) => {
        if (_.isEmpty(imagDescription) || _.isEmpty(imageName)) {
            toast.error("Please enter Image Name and description")
        } else {
            const imageFile = file;
            const formData = new FormData();
            formData.append('file', imageFile);
            formData.append('object_id', labId);
            formData.append('file_type', imageFile?.name)
            formData.append('name', imageName)
            formData.append('description', imagDescription)
            await uploadFileToServer(formData);
        }
    }
    const uploadFileToServer = async (formData) => {
        try {
            const result = await fileUploadServiceObj.getFileUploadUrl(formData);
            if (result) {
                getALLResource();
                setImageDescritption("");
                setImageName("");
            }

        }
        catch (error) {
            toast.error(error && error.url && error.url.message);
        }
    };

    const fileUpload = async (event) => {
        try {
            for (var index = 0; index < event.target.files.length; index++) {
                const imageFile = event.target.files[index];
                const isValidFormat = checkSupportedFormat(imageFile.name, supportedFileTypes);
                if (isValidFormat) {
                    const isValidSize = checkUploadedFileSize(imageFile, supportedFileMaxSize)
                    if (isValidSize) {
                        await createFormPayload(event, imageFile);
                    }
                    else toast.error(`${imageFile.name} file size is greater than ${supportedFileMaxSize} MB`);
                }
                else toast.error(`${imageFile.name} file's format not supported.`);
            }
            setFileData([...myRef.current]);

        } catch (error) {
            console.log(error);
        }
    }
    const fileClick = (evt) => evt.target.value = '';

    const resourceUrlClick = (evt) => {
        if (_.isEmpty(resourceName) || _.isEmpty(resourceUrl)) {
            toast.error("Please enter Resource Name and Resource URL.")
        } else {
            fileUploadServiceObj.uploadResourceUrl({
                "url": resourceUrl,
                "object_id": labId,
                "name": resourceName,
                "resources_type": selectedresourceType
            }).then(response => {
                if (response) {
                    toast.success("Resource Url added.");
                    setResourceName("");
                    setResourceUrl("");
                    setSelectedResourceType("");
                    getALLResource();
                }
            })
        }

    }

    const removeSelectedResourceUrl = (index, resourceId) => {
        fileUploadServiceObj.deleteResourceUrl(resourceId).then(response => {
            toast.error("Resource Url Removed");
            getALLResource();
        }).catch(error => {
            toast.error(error && error.url && error.url.toString());
        });
    }
    const removeSelectedFile = (index, resourceId) => {
        fileUploadServiceObj.getFileDeleteUrl(resourceId).then(response => {
            toast.error("File Removed");
            getALLResource();
        }).catch(error => {
            toast.error(error && error.url && error.url.toString());
        });
    }

    const openFileInNewTab = (url) => {
        window.open(url, '_blank').focus();
    }

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={2} >
                    <TextField
                        fullWidth
                        name="Name"
                        label="Name"
                        variant="outlined"
                        disabled={false}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            className: classes.inputLabel

                        }}
                        onChange={(e) => {
                            setResourceName(e.target.value)

                        }}
                        value={resourceName}
                    >
                    </TextField>
                </Grid>
                
                <Grid item xs={4} >
                    <TextField
                        fullWidth
                        name="resource_url"
                        label="Resource Url"
                        variant="outlined"
                        disabled={false}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            className: classes.inputLabel

                        }}
                        onChange={(e) => {
                            setResourceUrl(e.target.value)

                        }}
                        value={resourceUrl}
                    >
                    </TextField>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', alignSelf: 'center' }}>
                    <InputLabel
                    className={classes.selectLabel} >Type</InputLabel>
                    <Select
                    input={<BootstrapInput />}
                    onChange={(event) => {
                        setSelectedResourceType(event.target.value)
                    }
                    }
                    className={classes.select}>
                        {resourceType.map((option, index) => {
                            return (
                                <MenuItem key={uuid()} className={classes.menuItem} value={option.value}>{option.label}</MenuItem>
                            );
                        })}
                    </Select>
                </Grid>
                <Grid item xs={2} style={{ paddingTop: "26px" }}>
                    <Button
                        variant="contained"
                        component="label"
                        onClick={(e) => resourceUrlClick(e)}>
                        Add Resource Url
                    </Button>
                </Grid>
                
            {/* below code is commented for now. Decision pending from john on upload file */}
                {/* <Grid item xs={2} >
                    <TextField
                        fullWidth
                        name="Name"
                        label="Name"
                        variant="outlined"
                        disabled={false}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            className: classes.inputLabel

                        }}
                        onChange={(e) => {
                            setImageName(e.target.value)

                        }}
                        value={imageName}
                    >
                    </TextField>
                </Grid> */}
                {/* <Grid item xs={4} >
                    <TextField
                        fullWidth
                        name="Name"
                        label="Description of File"
                        variant="outlined"
                        disabled={false}
                        classes={{ root: classes.textField }}
                        InputProps={{
                            classes: {
                                input: classes.inputField,
                                root: classes.base,
                                focused: classes.focused,
                                notchedOutline: classes.notchedOutline
                            },
                        }}
                        InputLabelProps={{
                            shrink: true,
                            className: classes.inputLabel

                        }}
                        onChange={(e) => {
                            setImageDescritption(e.target.value)

                        }}
                        value={imagDescription}
                    >
                    </TextField>
                </Grid>
                <Grid item xs={2} style={{ paddingTop: "26px" }}>
                    <Button
                        variant="contained"
                        component="label"
                    >
                        Upload File
                        <input
                            type="file"
                            multiple
                            hidden
                            onClick={(e) => fileClick(e)}
                            onChange={(e) => fileUpload(e)}
                        />
                    </Button>
                </Grid> */}
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={6} className={classes.urlContainer}>
                    {
                        fileData.length > 0 ?
                            fileData && fileData.length > 0 && fileData.map((resource, index) => {
                                if (!_.isNull(resource?.url)) {
                                    return (
                                        <div key={uuid()} style={{ display: 'flex', marginBottom: 6, gap: 10 }}>
                                            <div>Resource Name : {resource?.name}</div>
                                            <div>Resource Type : {resource?.resources_type}</div>
                                            <div className={classes.fileName} onClick={() => openFileInNewTab(resource.url)}>{resource.url}</div>
                                            <Clear className={classes.clearIcon} onClick={() => removeSelectedResourceUrl(index, resource.id)} />
                                        </div>
                                    )
                                }

                            })
                            : <></>
                    }
                </Grid>
                <Grid item xs={6} className={classes.urlContainer}>
                    {fileData && fileData.length > 0 && fileData.map((file, index) => {
                        if (!_.isNull(file?.file))
                            return (
                                <div key={uuid()} style={{ display: 'flex', marginBottom: 6, gap: 10 }}>
                                    <div>File Name : {file.name}</div>
                                    <div>File description : {file.description}</div>
                                    <div className={classes.fileName} onClick={() => openFileInNewTab(file.file)}>{file.file_type}
                                    </div>
                                    <Clear className={classes.clearIcon} onClick={() => removeSelectedFile(index, file.id)} />
                                </div>
                            )
                    })}
                </Grid>
            </Grid>

        </>
    )
}